<div nz-row nzGutter="25">
  <!-- skeleton -->
  <ng-template #loadingSkeleton>
    <nz-skeleton class="bg-white dark:bg-white/10 rounded-6 p-[30px] pt-[15px]" [nzShape]="circle" [nzActive]="true"
      [nzParagraph]="{ rows: 12 }"></nz-skeleton>
  </ng-template>
  <!-- skeleton -->

  <div nz-col nzXs="24">
    <div nz-row nzGutter="25">
      <div nz-col nzXXl="6" nzLg="8" nzSm="12" nzXs="24" class="mb-[25px]" *ngFor="let card of pricing">
        <ng-container *ngIf="showContent; else loadingSkeleton">
          <div class="bg-white dark:bg-white/10 p-7 shadow-pricing dark:shadow-none rounded-10">
            <span
              class="inline-block bg-{{card.status}}/10 h-8 px-6 py-1.5 mb-8 text-{{card.status}} text-13 font-medium rounded-2xl capitalize dark:[&.text-dark]:bg-white/10 dark:[&.text-dark]:border-white/10 [&.text-dark]:dark:text-white/[.87]">{{ card.title }}</span>
            <h1
              class="relative bottom-1.5 mb-0 text-dark dark:text-white/[.87] text-4xl font-semibold capitalize flex items-center">
              <sup class="relative text-base font-semibold text-gray-400 -top-3">
                {{card.currency}}
              </sup>
              {{card.price}}
              <sub
                class="relative bottom-0 ml-2.5 text-light dark:text-white/60 text-13 font-normal capitalize">{{card.pricePeriod}}</sub>
            </h1>
            <span class="font-medium text-body dark:text-white/60 text-13">{{card.subtitle}}</span>
            <div class="mt-6 mb-4 min-h-[210px]">
              <div class="flex items-center mb-3 text-body dark:text-white/60 gap-[15px]"
                *ngFor="let feature of card.features">
                <span class="text-success text-[14px]" nz-icon nzType="{{ feature.icon }}" nzTheme="outline"></span>
                <span class="text-15">{{ feature.text }}</span>
              </div>
            </div>
            <button nz-button
              class="text-sm font-semibold bg-{{card.status}} hover:bg-{{card.status}}-hbr rounded-md text-white dark:text-white/[.87]  h-11 px-7 border-{{card.status}} capitalize duration-200 dark:[&.bg-dark]:bg-white/10 dark:[&.bg-dark]:border-white/10 [&.bg-dark]:dark:text-white/[.87]">
              <span>{{ card.buttonText }}</span>
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div nz-col nzXs="24">
    <div nz-row nzGutter="25">
      <div nz-col nzXXl="6" nzLg="8" nzSm="12" nzXs="24" class="mb-[25px]" *ngFor="let card of pricing">
        <ng-container *ngIf="showContent; else loadingSkeleton">
          <div class="bg-white dark:bg-white/10 p-7 shadow-pricing dark:shadow-none rounded-10">
            <span
              class="inline-block bg-{{card.status}}/10 h-8 px-6 py-1.5 mb-8 text-{{card.status}} text-13 font-medium rounded-2xl capitalize dark:[&.text-dark]:bg-white/10 dark:[&.text-dark]:border-white/10 [&.text-dark]:dark:text-white/[.87]">{{ card.title }}</span>
            <h1
              class="relative bottom-1.5 mb-0 text-dark dark:text-white/[.87] text-[24px] font-semibold capitalize flex items-center">
              <sup class="relative text-base font-semibold text-gray-400 -top-3">
                {{card.currency}}
              </sup>
              {{card.price}}
              <sub
                class="relative bottom-0 ml-2.5 text-dark dark:text-white/[.87] text-17 font-semibold capitalize">{{card.pricePeriod}}</sub>
            </h1>
            <span class="font-medium text-body dark:text-white/60 text-13">{{card.subtitle}}</span>
            <div class="mt-6 mb-4 min-h-[210px]">
              <div class="flex items-center mb-3 text-body dark:text-white/60 gap-[15px]"
                *ngFor="let feature of card.features">
                <span class="text-success text-[14px]" nz-icon nzType="{{ feature.icon }}" nzTheme="outline"></span>
                <span class="text-15">{{ feature.text }}</span>
              </div>
            </div>
            <button nz-button
              class="text-sm font-semibold bg-{{card.status}} hover:bg-{{card.status}}-hbr rounded-md text-white dark:text-white/[.87]  h-11 px-7 border-{{card.status}} capitalize duration-200 dark:[&.bg-dark]:bg-white/10 dark:[&.bg-dark]:border-white/10 [&.bg-dark]:dark:text-white/[.87]">
              <span>{{ card.buttonText }}</span>
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
